import { Container, Row, Col, Image } from 'react-bootstrap'
import Website from '@group-devs/yfp7-global-modules/utils/request/WebsiteRequest'
import { getUrl } from '@group-devs/yfp7-global-modules/utils/general'
import {useEffect,useState} from 'react'

const website = new Website(process.env.apiDomain)


const About = ({ global, avatar }) => {
    const id= "About"
    const { data: pageContent, isLoading } = website.swrPageContent(getUrl(global.host, global.path))
    const [about, setAbout] = useState({photo: null, about: null})
    
    const defaultPhoto = avatar || '/images/7bs/profile-default.jpg';
    
    const DefaultAbout = () => (
        <>
            <p>Thanks for visiting my site!</p>
            <p>I&#8217;m excited to have the chance to share this incredibly important and possibly life altering information with you. It&#8217;s actually about more than just helping you look better and lose some weight. It addresses the most important issue you face.</p>
            <p><strong>Your health!</strong></p>
            <p>Your health is your greatest wealth. If you lose this valuable asset, you&#8217;ll end up spending everything you have emotionally and financially to get it back. And it&#8217;s now been proven that maintaining a healthy weight is a critical factor in living a healthy, disease-free life.</p>
            <p>One of the main reasons I want to share this e-book with as many people as possible, is because I&#8217;m tired of seeing people and their families struggle to find the right answers for maintaining a healthy weight. I hope my special report can help you as much as it&#8217;s helped so many others who&#8217;ve already read it.</p>
            <p>Here&#8217;s to your healthy weight!</p>
        </>
    )
    
    useEffect(()=>{
        if (pageContent)
        {
            let content = JSON.parse(pageContent.content)
            if (content && content[id])
                setAbout({...content[id]})
        }
    },[pageContent])

return (
    <>
    <div className="section-about">
        <Container>
            <Row>
                <Col md={4} className="mb-4">
                    { !isLoading ? 
                        <Image src={about.photo ? about.photo : defaultPhoto } alt="About" className="img-fluid d-block mx-auto mb-4"/>
                    : null }
                </Col>
                <Col md={8} className="mb-4">
                    <h2 className="mb-4">About Me</h2>
                    { !isLoading ?
                        about.about ? <div dangerouslySetInnerHTML={{ __html: about.about }} />
                        : <DefaultAbout/>
                    : null }
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-about {
                background: #EEE9E3;
                font-size: 17px;
            }

            .section-about .container {
                padding-top: 80px;
                padding-bottom: 80px;
            }

            .section-about h2 {
                color: #de7621;
                font-size: 40px;
            }

            @media (max-width: 767.98px) {

                .section-about .container {
                    padding-bottom: 40px;
                }

                .section-about h2 {
                    font-size: 30px;
                }

            }

        `}</style>
    </>
)
}

export default About;